import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import {post} from "../../../helper/request";
import querystring from "query-string";
import {getEuclideanDistance, getLoggedInUserId} from "../../../utils/utils";
import {getAnnotationsFeature} from "../utils/annotations_app_utils";
import VectorSource from "ol/source/Vector";
import Polygon from "./Polygon";
import {store} from "../../../helper/store";
import {updateMagicToolDataRetrievalStatus} from "../../../redux_actions/gamma.state.action";
import {notifyCustomErrors} from "../utils/display.notification";
import {Fill, Stroke, Style} from "ol/style";

class MagicTool extends Polygon {
    id = "MagicTool";
    name = "MagicTool";
    type = "LineString";
    icon = <AutoFixHighOutlinedIcon/>;
    className = "MagicTool-forTour"
    maxPoints = 2;
    shortcutKey = "7";
    features = []

	drawOngoing = false;

	clearCanvas = () => {
		this.features = [];
		this.feature = null;
		this.getMagicLayer().getSource().clear();
	}

    onDrawStart = (event) => {
		this.drawOngoing = true;
        this.clearCanvas();
		store.dispatch(updateMagicToolDataRetrievalStatus(true))
		let geometry = event.feature.getGeometry();
        geometry.on('change', this.onGeometryChange);
        post(`/api/magictool_detector/`, querystring.stringify({
            start_point: JSON.stringify(geometry.getCoordinates()[0]),
            z: this.props.slidemap.getView().getZoom(),
            slide: this.props.slide.id,
            extent: JSON.stringify(this.props.slidemap.getView().calculateExtent(this.props.slidemap.getSize())),
            user_id: getLoggedInUserId(),
        })).then(getAnnotationsFeature).catch((err) => {
			notifyCustomErrors(err)
			store.dispatch(updateMagicToolDataRetrievalStatus(false))

		}).then(features => {
            this.features = features || []
            store.dispatch(updateMagicToolDataRetrievalStatus(false))
			this.onGeometryChange(event);
        }).catch(() => store.dispatch(updateMagicToolDataRetrievalStatus(false)));
    }

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (prevProps.selected !== this.props.selected && this.props.selected === false) {
			this.clearCanvas()
		}
	}

	getMagicLayer = () => this.props.slidemap.getLayers().getArray().find(layer => layer.get('id') === this.id);

	onGeometryChange = (event) => {
		if (this.features.length === 0 || !this.drawOngoing) return null;
		let coords;
		if (event?.type === "drawstart") {
			coords = [[0,0],[0,0]]
		} else {
			coords = event.target.getCoordinates();
		}
		let index = Math.round(getEuclideanDistance(coords) / 150);
		this.feature = this.features[index] || this.features[this.features.length - 1];
		this.getMagicLayer().setSource(new VectorSource({
			features: [this.feature],
			wrapX: false
		}));
		this.getMagicLayer().setVisible(true);
	}

	onDrawEnd = (event) => {
		this.drawOngoing = false;
		const hiddenStyle = new Style({
			stroke: new Stroke({
				color: 'rgba(0, 0, 0, 0)',
				width: 0
			}),
			fill: new Fill({
				color: 'rgba(0, 0, 0, 0)'
			})
		});

		this.feature && this.addFeatureAnnotation(this.feature);
		event.feature && event.feature.setStyle(hiddenStyle);
		this.clearCanvas()
	}
}

export default MagicTool;
